import { Disposer } from "common/disposer";
import { createPromise } from "common/promises";
export class OnEvent {
    constructor(option) {
        this.filter = () => true;
        this.used = false;
        this.hasFiredBefore = () => false;
        this.waitContext = null;
        this.handleEvent = this.handleEvent.bind(this);
        this.eventName = option.eventName;
        this.selector = option.selector;
        if (option.filter) {
            this.filter = option.filter;
        }
        if (option.hasFiredBefore) {
            this.hasFiredBefore = option.hasFiredBefore;
        }
    }
    async waitOnce() {
        if (this.used) {
            throw new Error("disposed on event is reused");
        }
        this.used = true;
        const element = $(this.selector);
        const disposer = new Disposer(() => {
            element.off(this.eventName, this.handleEvent);
            this.waitContext = null;
        });
        try {
            const { resolve, reject, promise } = await createPromise();
            this.waitContext = {
                promise: { resolve, reject },
                element,
            };
            element.on(this.eventName, this.handleEvent);
            if (this.hasFiredBefore(element)) {
                return;
            }
            await promise;
        }
        finally {
            disposer.dispose();
        }
    }
    handleEvent(ev) {
        if (this.waitContext) {
            const { promise: { resolve }, element, } = this.waitContext;
            if (this.filter(ev, element)) {
                resolve();
            }
        }
    }
}
//# sourceMappingURL=onEvent.js.map